// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-XScrollContainer-module--cls1--MK-SV","cls2":"styles-XScrollContainer-module--cls2--3eRsl styles-XScrollContainer-module--cls1--MK-SV"};